var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.215,
    height: 18,
    viewBox: "0 0 15.215 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_318",
    "data-name": "Subtraction 318",
    d: "M18375.7-9227.449h-4.645a2.5,2.5,0,0,1-2.5-2.5v-12.994a2.5,2.5,0,0,1,2.5-2.5h5.582l.242.081.066.019.039,0a1.106,1.106,0,0,1,.148.1l5.555,5.554a.888.888,0,0,1,.1.144v.062l.016.043c.016.058.031.12.043.181v2.822a.647.647,0,0,1-.648.646.645.645,0,0,1-.641-.646v-2.142h-3.07a2.505,2.505,0,0,1-2.5-2.5v-3.07h-4.926a1.211,1.211,0,0,0-1.207,1.214v12.994a1.21,1.21,0,0,0,1.207,1.213h4.645a.646.646,0,0,1,.645.647A.644.644,0,0,1,18375.7-9227.449Zm1.57-15.8h0v2.16a1.214,1.214,0,0,0,1.215,1.208h2.16l-3.375-3.368Zm1.215,13.95a.656.656,0,0,1-.461-.19l-2.785-2.784a.731.731,0,0,1-.129-.205l0-.009a.628.628,0,0,1,0-.49.8.8,0,0,1,.137-.219l2.781-2.779a.656.656,0,0,1,.461-.19.64.64,0,0,1,.457.19.65.65,0,0,1,0,.913l-1.7,1.685h5.879a.644.644,0,0,1,.645.643.647.647,0,0,1-.645.647h-5.879l1.7,1.68a.665.665,0,0,1,.184.458.653.653,0,0,1-.187.461A.64.64,0,0,1,18378.48-9229.3Z",
    transform: "translate(-18368.551 9245.449)",
    fill: "currentColor",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import-icon.85d48b86e4fd60f0c86a7530111cbcfe.svg";
export { ForwardRef as ReactComponent };